<template>
  <div
    class="modal fade ag-modal ag-user-modal"
    id="agUserModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 v-if="!userFormValues.id">Create New User</h3>
          <h3 v-if="userFormValues.id">Edit User</h3>
        </div>
        <Form
          @submit="onSubmit"
          autocomplete="off"
          ref="form"
          :key="compKey"
          :validation-schema="userFormValues.id ? schemaNoPass : schema"
          :initial-values="userFormValues"
          v-slot="{ meta, resetForm }"
        >
          <input
            autocomplete="false"
            name="hidden"
            type="text"
            style="display: none"
          />
          <div class="modal-body">
            <div class="ag-modal-form w-100">
              <ul class="ag-modal-form-list">
                <li>
                  <span class="bold-text">Role : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field
                        name="role"
                        v-slot="{ field, meta }"
                        v-model="userFormValues.role"
                        @change="handleRoleChange"
                      >
                        <select
                          class="form-control"
                          name="role"
                          :disabled="userFormValues.id || loading"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                          <option value="" disabled selected>
                            Select a Role
                          </option>
                          <option
                            v-for="(item, key) in userRoles"
                            :key="key"
                            :value="item.value"
                            v-role="item.roles"
                          >
                            {{ item.label }}
                          </option>
                          <option
                            v-for="(item, key) in userRoles"
                            :key="key"
                            v-show="
                              userFormValues.id &&
                              loggedInUser.role == Roles.AGMSAdmin &&
                              item.value !== Roles.AGMSAdmin &&
                              item.value !== Roles.CompanyAdmin
                            "
                            disabled
                            :value="item.value"
                          >
                            {{ item.label }}
                          </option>
                        </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="role"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="userFormValues.role === Roles.PartnerAdmin">
                  <span class="bold-text">Partner : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field
                        name="partnerId"
                        v-slot="{ field, meta }"
                        v-model="userFormValues.partnerId"
                        @change="handlePartnerChange"
                      >
                        <select
                          name="partnerId"
                          class="form-control"
                          required
                          :disabled="userFormValues.id || loading"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                          <option value="" disabled selected>
                            Select Partner
                          </option>
                          <option
                            v-for="(item, key) in partners"
                            :key="key"
                            :value="item.id"
                            v-role="item.roles"
                          >
                            {{ item.name }}
                          </option>
                        </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="partnerId"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="userFormValues.role === Roles.CompanyAdmin">
                  <span class="bold-text">Company : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field
                        name="companyId"
                        v-slot="{ field, meta }"
                        v-model="userFormValues.companyId"
                        @change="handleCompanyChange"
                      >
                        <select
                          name="companyId"
                          class="form-control"
                          required
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                          :disabled="userFormValues.id || loading"
                        >
                          <option value="" disabled selected>
                            Select Company
                          </option>
                          <option
                            v-for="(item, key) in companies"
                            :key="key"
                            :value="item.companyGuid"
                            v-role="item.roles"
                          >
                            {{ item.companyName }}
                          </option>
                        </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="companyId"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li
                  v-if="
                    userFormValues.role === Roles.SiteAdmin ||
                    userFormValues.role === Roles.SiteAudit ||
                    userFormValues.role === Roles.GroupAdmin ||
                    userFormValues.role === Roles.GroupAudit
                  "
                >
                  <span class="bold-text">Sites : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field
                        name="sites"
                        v-slot="{ field, meta }"
                        v-model="userFormValues.sites"
                        @change="handleSiteChange"
                      >
                        <multiselect
                          :options="sites"
                          v-bind="field"
                          v-model="userFormValues.sites"
                          :mode="
                            userFormValues.role === Roles.GroupAdmin
                              ? 'single'
                              : 'tags'
                          "
                          placeholder="Select Site"
                          searchable="true"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                          :disabled="userFormValues.id || loading"
                        ></multiselect>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="sites"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li
                  v-if="
                    userFormValues.sites &&
                    userFormValues.role === Roles.GroupAdmin
                  "
                >
                  <span class="bold-text">Groups : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field
                        name="groups"
                        v-slot="{ field, meta }"
                        v-model="userFormValues.groups"
                      >
                        <multiselect
                          :options="groups"
                          v-bind="field"
                          v-model="userFormValues.groups"
                          placeholder="Select Groups"
                          mode="tags"
                          :key="groupKey"
                          :close-on-select="true"
                          :searchable="true"
                          :filter-results="false"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                          :disabled="userFormValues.id || loading"
                        ></multiselect>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="groups"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>

                <li>
                  <span class="bold-text">First Name : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="firstName" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="firstName"
                          maxlength="191"
                          v-model="userFormValues.firstName"
                          class="form-control"
                          placeholder="Enter Your First Name"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="firstName"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">Last Name : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="lastName" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="lastName"
                          maxlength="191"
                          v-model="userFormValues.lastName"
                          class="form-control"
                          placeholder="Enter Your Last Name"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="lastName"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">E-Mail : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="email" v-slot="{ field, meta }">
                        <input
                          type="email"
                          name="email"
                          maxlength="191"
                          autoComplete="new-email"
                          :disabled="userFormValues.id"
                          v-model="userFormValues.email"
                          class="form-control"
                          placeholder="Enter Your E-Mail"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                          required
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="email"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li v-if="!userFormValues.id">
                  <span class="bold-text">Password : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="password" v-slot="{ field, meta }">
                        <div class="position-relative">
                          <input
                            v-model="userFormValues.password"
                            :required="!userFormValues.id"
                            :type="!showPass ? 'password' : 'text'"
                            placeholder="Enter Your Password"
                            name="password"
                            autoComplete="new-password"
                            class="form-control"
                            v-bind="field"
                            :class="{
                              'form-error-input': meta.touched && !meta.valid,
                            }"
                          />
                          <a
                            href="javascript:;"
                            class="generate-btn"
                            @click="generate(resetForm)"
                            >Generate</a
                          >
                          <a
                            href="javascript:;"
                            v-if="userFormValues.password"
                            class="generate-btn copy-btn"
                            @click="copy"
                            >Copy</a
                          >
                          <a
                            href="javascript:;"
                            class="generate-btn show-hide-btn"
                            @click="showHidePassword()"
                          >
                            <i
                              class="ag-icon ag-icon_show mr-2"
                              v-if="!showPass"
                            ></i>
                            <i
                              class="ag-icon ag-icon_hide mr-2"
                              v-if="showPass"
                            ></i>
                          </a>
                        </div>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="password"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              :disabled="!meta.valid || loading"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary float-inline-end"
            >
              Save
            </button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { useStore } from "@/store";
import { notify } from "@kyvg/vue3-notification";
import { Roles } from "@/helpers/enums/Roles";
import api from "@/api/index";
import apiAGSC from "@/store/axiosAgsc";
import apiIdentity from "@/store/axiosIdentity";
import Multiselect from "@vueform/multiselect";
import generator from "generate-password";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

const store = useStore();

export default {
  name: "ag-user-modal",
  components: {
    Multiselect,
    Field,
    Form,
    ErrorMessage,
  },
  props: {
    selectedUser: {},
  },
  data() {
    const schema = Yup.object().shape({
      role: Yup.string().required().label("Role"),
      firstName: Yup.string().required().label("First Name"),
      lastName: Yup.string().required().label("Last Name"),
      email: Yup.string().email().required().label("Email"),
      password: Yup.string().required().label("Password"),
    });
    const schemaNoPass = Yup.object().shape({
      role: Yup.string().required().label("Role"),
      firstName: Yup.string().required().label("First Name"),
      lastName: Yup.string().required().label("Last Name"),
      email: Yup.string().email().required().label("Email"),
      password: Yup.string().label("Password"),
    });
    return {
      schema,
      schemaNoPass,
      loading: false,
      showPass: false,
      Roles: Roles,
      sites: [],
      groups: [],
      groupKey: 0,
      userFormValues: {
        role: "",
        password: "",
        companyId: null,
        partnerId: null,
        sites: [],
        groups: [],
        firstName: "",
        lastName: "",
        email: "",
      },
      userRoles: [
        {
          label: "Appguard Admin",
          value: "Global Admin",
          roles: [Roles.AGMSAdmin],
        },
        {
          label: "Partner Admin",
          value: "Partner Admin",
          roles: [Roles.AGMSAdmin, Roles.PartnerAdmin],
        },
        {
          label: "Company Administrator",
          value: "Company Administrator",
          roles: [Roles.PartnerAdmin, Roles.CompanyAdmin],
        },
        {
          label: "Site Administrator",
          value: "Site Administrator",
          roles: [Roles.CompanyAdmin],
        },
        {
          label: "Group Administrator",
          value: "Group Administrator",
          roles: [Roles.CompanyAdmin],
        },
        // {
        //   label: "Site Auditor",
        //   value: "Site Auditor",
        //   roles: [Roles.CompanyAdmin],
        // },
        // {
        //   label: "Group Auditor",
        //   value: "Group Auditor",
        //   roles: [Roles.CompanyAdmin],
        // },
      ],
      companies: [],
      partners: [],
      scopes: [],
    };
  },
  watch: {
    async selectedUser() {
      if (this.selectedUser && this.selectedUser.id) {
        await this.fillPartners();
        this.userFormValues = this.selectedUser;
        this.userFormValues.companyId = this.selectedUser.companies[0];
        this.fillSites(this.selectedUser.companies[0]);
        this.fillGroups(this.selectedUser.sites[0]);
      }
    },
    compKey() {
      this.userFormValues = {
        role: "",
        password: "",
        companyId: null,
        partnerId: null,
        sites: [],
        groups: [],
        firstName: "",
        lastName: "",
        email: "",
      };
    },
  },
  computed: {
    ...mapGetters(["loggedInUser", "partner"]),
    company() {
      return store.getters.company;
    },
    compKey() {
      return store.getters.compKey;
    },
    realRole() {
      return localStorage.getItem("realRole");
    },
  },
  mounted() {
    this.getCompanies();
    this.getScopeData();
  },
  methods: {
    showHidePassword() {
      this.showPass = !this.showPass;
    },
    handleRoleChange(e) {
      this.userFormValues.sites = [];
      this.userFormValues.groups = [];
      if (
        e.target.value === Roles.SiteAdmin ||
        e.target.value === Roles.SiteAudit ||
        e.target.value === Roles.GroupAdmin ||
        e.target.value === Roles.GroupAudit
      ) {
        const companyGuid = this.company.companyGuid;
        if (!companyGuid || typeof companyGuid === undefined) {
          return;
        }
        this.fillSites(companyGuid);
      }
      if (e.target.value === Roles.PartnerAdmin) {
        this.fillPartners();
      }
    },
    handleCompanyChange(e) {
      this.fillSites(e.target.value);
      this.fillSiteAndGroups(e.target.value);
    },
    async getScopeData() {
      const scopeData = await api.companies.getScopeTree();
      this.scopes = scopeData.data.entityData;
    },
    async handlePartnerChange(e) {
      const find = this.scopes.nodes.find((i) => i.guid === e.target.value);
      this.userFormValues.companies = [];
      this.userFormValues.sites = [];
      this.userFormValues.groups = [];
      if (find) {
        find.nodes.forEach((company) => {
          if (company.type == 1) {
            this.userFormValues.companies.push(company.guid);
          } else if (company.type == 2) {
            this.userFormValues.sites.push(company.guid);
          } else if (company.type == 3) {
            this.userFormValues.groups.push(company.guid);
          }
          if (company.nodes) {
            company.nodes.forEach((site) => {
              if (site.type == 1) {
                this.userFormValues.companies.push(site.guid);
              } else if (site.type == 2) {
                this.userFormValues.sites.push(site.guid);
              } else if (site.type == 3) {
                this.userFormValues.groups.push(site.guid);
              }
              if (site.nodes) {
                site.nodes.forEach((group) => {
                  if (group.type == 1) {
                    this.userFormValues.companies.push(group.guid);
                  } else if (group.type == 2) {
                    this.userFormValues.groups.push(group.guid);
                  } else if (group.type == 3) {
                    this.userFormValues.groups.push(group.guid);
                  }
                });
              }
            });
          }
        });
      }
    },
    async handleSiteChange(e) {
      if (!Array.isArray(e)) {
        this.fillGroups(e);
      } else {
        e.forEach((element) => {
          this.fillGroups(element);
        });
      }
    },
    async getCompanies() {
      const res = await api.companies.get({
        pageSize: 99999,
      });
      this.companies = res.data.entityData;
    },
    async fillPartners() {
      if (
        this.realRole === Roles.AGMSAdmin ||
        this.realRole === Roles.PartnerAdmin
      ) {
        const res = await api.partners.get();
        this.partners = res.data.entityData;
      }
    },
    async fillSiteAndGroups(companyGuid) {
      const res = await apiAGSC.get(
        `/Asset/GetAllSitesAndGroupsForCompany?companyGuid=${companyGuid}`,
        {}
      );
      const arr = {
        groupGuids: [],
        siteGuids: [],
      };
      res.data.entityData.groupGuids.forEach((element) => {
        arr.groupGuids.push(element);
      });
      res.data.entityData.siteGuids.forEach((element) => {
        arr.siteGuids.push(element);
      });
      this.groups = arr.groupGuids;
      this.sites = arr.siteGuids;
      this.userFormValues.groups = arr.groupGuids;
      this.userFormValues.sites = arr.siteGuids;
    },
    async fillGroups(siteGuid) {
      if (!siteGuid || typeof siteGuid === undefined) {
        return;
      }
      const res = await apiAGSC.get(
        `/Group/GetSiteGroups?siteGuid=${siteGuid.replaceAll("_", "-")}`,
        {}
      );
      const arr = [];
      if (res.data && res.data.entityData) {
        if (this.userFormValues.role == Roles.SiteAdmin) {
          this.userFormValues.groups = [];
        }

        res.data.entityData.forEach((element) => {
          arr.push({
            value: element.groupGuid,
            label: element.name,
          });
          if (this.userFormValues.role == Roles.SiteAdmin) {
            this.userFormValues.groups.push(element.groupGuid);
          }
        });
      }
      this.groups = arr;
      ++this.groupKey;
    },
    async fillSites(companyGuid) {
      if (!companyGuid || typeof companyGuid === undefined) {
        return;
      }

      const res = await apiAGSC.get(
        `/Site/GetSitesByCompanyId?companyId=${companyGuid.replaceAll(
          "_",
          "-"
        )}`,
        {}
      );
      const arr = [];
      if (res.data && res.data.entityData) {
        res.data.entityData.forEach((element) => {
          arr.push({
            value: element.siteGuid,
            label: element.name,
          });
        });
      }
      this.sites = arr;
    },
    async onSubmit() {
      this.loading = true;
      const body = this.userFormValues;
      if (this.userFormValues.companyId) {
        body["companies"] = [this.userFormValues.companyId];
        body["companyId"] = this.userFormValues.companyId;
      } else if (
        this.userFormValues &&
        this.userFormValues.companies &&
        this.userFormValues.companies.length
      ) {
        body["companyId"] = this.userFormValues.companies[0];
      } else {
        if (this.company.companyGuid) {
          body["companies"] = [this.company.companyGuid];
          body["companyId"] = this.company.companyGuid;
        } else {
          body["companies"] = [];
          body["companyId"] = "";
        }
      }

      if (Array.isArray(this.userFormValues.sites)) {
        body["sites"] = this.userFormValues.sites;
      } else {
        body["sites"] = [this.userFormValues.sites];
      }
      if (Array.isArray(this.userFormValues.groups)) {
        body["groups"] = this.userFormValues.groups;
      } else {
        body["groups"] = [this.userFormValues.groups];
      }

      if (this.loggedInUser.role !== Roles.AGMSAdmin) {
        if (this.partner && this.partner.guid) {
          body["partnerId"] = this.partner.guid;
        } else {
          const partnerId = (
            store.state.auth.user.find((f) => f.type == "PartnerId") || {}
          ).value;
          console.log(partnerId);
          if (partnerId) {
            body["partnerId"] = partnerId;
          }
        }
      }

      let request = "post";
      if (this.userFormValues.id) {
        request = "put";
      }
      apiIdentity[request]("User", body)
        .then((res) => {
          let errors = [];
          if (res.data.status && res.data.status !== 200 && res.data.errors) {
            errors = res.data.errors;
          } else if (
            res.data.Status &&
            res.data.Status !== 200 &&
            res.data.Errors
          ) {
            errors = res.data.Errors;
          } else if (
            res.data.statusCode &&
            res.data.statusCode !== 200 &&
            res.data.errors
          ) {
            errors = res.data.errors;
          } else if (
            res.data.StatusCode &&
            res.data.StatusCode !== 200 &&
            res.data.Errors
          ) {
            errors = res.data.Errors;
          } else if (
            (res.data.statusCode && res.data.statusCode !== 200) ||
            (res.data.status && res.data.status !== 200 && res.data.Message)
          ) {
            errors = [res.data.Message];
          }
          if (errors.length > 0) {
            const errorMessage = errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: "An Error Occurred..",
              type: "error",
              text:
                "<p>" +
                res.data.Message +
                "</p>" +
                "<ul>" +
                errorMessage +
                "</ul>",
              duration: 8000,
              closeOnClick: true
            });
          } else {
            this.$emit("formsuccess");
            this.closeAllModals();
            notify({
              title:
                request == "put"
                  ? "User successfully updated"
                  : "User added successfully",
              type: "success",
              duration: 4000,
              closeOnClick: true
            });
            store.dispatch(
              GeneralActionTypes.SET_COMPKEY,
              store.getters.compKey + 1
            );
            store.dispatch(GeneralActionTypes.GET_USERS, {
              options: {
                sortable: {
                  order: "createdAt",
                  sort: "desc",
                },
                total: 0,
                page: 1,
                pageSize: 10,
              },
              filters: {},
            });
          }
        })
        .catch((e) => {
          console.log(e);
          if (e && e.errors) {
            const errors = e.errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: "An Error Occurred..",
              type: "error",
              text: "<p>" + e.message + "</p>" + "<ul>" + errors + "</ul>",
              duration: 8000,
              closeOnClick: true
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generate(resetForm) {
      const password = generator.generate({
        length: 10,
        numbers: true,
        strict: true,
        symbols: true,
      });
      this.userFormValues.password = password;
      resetForm(this.userFormValues);
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.userFormValues.password);
        notify({
          title: "Copied",
          type: "success",
          duration: 3000,
          closeOnClick: true
        });
      } catch ($e) {
        notify({
          title: "Cannot copy",
          type: "error",
          duration: 3000,
          closeOnClick: true
        });
      }
    },
    closeAllModals() {
      const modals = document.getElementsByClassName("modal");

      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove("show");
        modals[i].setAttribute("aria-hidden", "true");
        modals[i].setAttribute("style", "display: none");
      }

      const modalsBackdrops = document.getElementsByClassName("modal-backdrop");

      for (let i = 0; i < modalsBackdrops.length; i++) {
        document.body.removeChild(modalsBackdrops[i]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}

.ag-modal-form-list {
  margin-left: 30px;
}

.ag-modal .modal-body label input {
  margin-right: 4px;
}

.ag-modal-form-list li {
  width: 86%;
}

.ag-modal-form-list li .bold-text {
  text-align: left !important;
  width: 33% !important;
}

.copy-button {
  margin-left: -42px;
  position: relative;
  left: 50px;
}

.error-wrapper {
  display: block;
  width: 100%;
}
li.form-group-full {
  display: flex;
  flex-direction: column;
}

.generate-btn {
  position: absolute;
  top: 8px;
  right: 44px;
  font-size: 14px;

  &.copy-btn {
    right: 110px;
  }
  &.show-hide-btn {
    right: 10px;
  }
}

.position-relative {
  width: 100%;
  display: block;
}
</style>
